/** Session seed so Discover order is random per load but stable across pagination pages. */

function seedStorageKey(userId) {
  return `discover-rec-seed:${userId}`;
}

export function getRecommendationsSeed(userId) {
  if (!userId || typeof sessionStorage === "undefined") return null;
  try {
    const existing = sessionStorage.getItem(seedStorageKey(userId));
    if (existing) return existing;
    return refreshRecommendationsSeed(userId);
  } catch {
    return createRecommendationsSeed();
  }
}

export function refreshRecommendationsSeed(userId) {
  const seed = createRecommendationsSeed();
  if (!userId || typeof sessionStorage === "undefined") return seed;
  try {
    sessionStorage.setItem(seedStorageKey(userId), seed);
  } catch {
    // ignore quota / private mode
  }
  return seed;
}

function createRecommendationsSeed() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
